import React, { useState, useEffect } from "react";
import { Edit, Trash2, Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./RegionList.css";

const url = process.env.REACT_APP_BACKEND_URL;

const RegionList = () => {
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchRegions = async () => {
    try {
      const res = await axios.get(`${url}/api/regions`);
      setRegions(res.data.data || []);
    } catch (err) {
      alert(err.response?.data?.message || "Failed to fetch regions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRegions();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this region?")) {
      try {
        await axios.delete(`${url}/api/regions/${id}`);
        fetchRegions();
        alert("Region deleted successfully");
      } catch (err) {
        alert(err.response?.data?.message || "Failed to delete region");
      }
    }
  };

  if (loading) return <div className="loading">Loading regions...</div>;

  return (
    <div className="region-container">
      <div className="header">
        <h2>Regions</h2>
        <button
          onClick={() => navigate("/regions/add")}
          className="add-button"
        >
          <Plus size={16} /> Add Region
        </button>
      </div>

      <table className="region-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Country</th>
            <th style={{ textAlign: "center", width: "120px" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {regions.length === 0 ? (
            <tr>
              <td colSpan="3" className="no-data">
                No regions found
              </td>
            </tr>
          ) : (
            regions.map((region) => (
              <tr key={region._id}>
                <td>{region.name}</td>
                <td>{region.country?.name}</td>
                <td className="actions-cell">
                  <div className="actions">
                    <button
                      onClick={() => navigate(`/regions/edit/${region._id}`)}
                      className="edit-btn"
                      title="Edit"
                    >
                      <Edit size={14} />
                    </button>
                    {/* <button
                      onClick={() => handleDelete(region._id)}
                      className="delete-btn"
                      title="Delete"
                    >
                      <Trash2 size={14} />
                    </button> */}
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default RegionList;
